module.exports = __webpack_public_path__ + "media/images/vp/icon.tt.red-00a8311101d78204799c15c45e5adb69.png";